<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);">
<mat-spinner></mat-spinner>
</div>
